/*eslint-disable*/
import Config from "Data"

const qs = require("query-string")

export const isBrowser = () => typeof window !== "undefined"

export const isDev = process.env.NETLIFY_DEV

export const endpoints = {
  referee: "/.netlify/functions/referee",
  contact: "/.netlify/functions/contact",
  log: "/.netlify/functions/log",
  manage: "/.netlify/functions/manage",
}

export const BrandColor = (name) => {
  switch (name?.toLowerCase()) {
    case "cxosync":
      return Config.brandsColors.cxosync
    case "ciocamps":
      return Config.brandsColors.ciocamps
    case "securecamps":
      return Config.brandsColors.cisocamps
    case "cisocamps":
      return Config.brandsColors.cisocamps
    case "cfocamps":
      return Config.brandsColors.cfocamps
    case "cmocamps":
      return Config.brandsColors.cmocamps
    case "chrocamps":
      return Config.brandsColors.hr
    case "ciosynergy":
      return Config.brandsColors.ciosynergy
    case "fintechcio":
      return Config.brandsColors.fintechcio
    case "ciohealth":
      return Config.brandsColors.ciohealth
    case "secureciso":
      return Config.brandsColors.secureciso
    case "ciso":
      return Config.brandsColors.secureciso
    case "fintechciso":
      return Config.brandsColors.fintechciso
    case "cfo.org":
      return Config.brandsColors.cfoorg
    case "cmo.org":
      return Config.brandsColors.cmoorg
    case "merchant.org":
      return Config.brandsColors.merchantorg
    case "hr":
      return Config.brandsColors.hr
    case "cx":
      return Config.brandsColors.cx
    case "eps":
      return Config.brandsColors.eps
    case "cxosports":
      return Config.brandsColors.cxosports
    case "cxostories":
      return Config.brandsColors.cxostories
    case "panels":
      return Config.brandsColors.panels
    case "notice":
      return Config.brandsColors.notice
    case "white":
      return Config.brandsColors.white
    default:
      return Config.brandsColors.default
  }
}

export const isEmpty = (obj) => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false
  }
  return true
}

export const isLocalhost = () =>
  Boolean(
    window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
  )

export const getUrlParam = (param) => {
  if (isBrowser()) {
    return window.siteUtil.util.getUrlParameter(param)
  }
}

export const setUrlParam = (key, value) => {
  if (isBrowser()) {
    return window.siteUtil.util.setUrlParametersByType(key, value)
  }
}

export const getLocalStorage = (key) => {
  if (isBrowser()) {
    return window.siteUtil.util.getLocalStorage(key)
  }
}

export const setLocalStorage = (key, value) => {
  if (isBrowser()) {
    return window.siteUtil.util.setLocalStorage(key, value)
  }
}

export const getShareURL = () => {
  if (isBrowser()) {
    return window.location
  }
}

export const getWindowParamsObj = () => {
  if (isBrowser()) {
    var windowURL = qs.parse(window.location.search)
    return windowURL
  }
}

export const leadInfo = () => {
  if (isBrowser()) {
    var leadInfo = {
      campaign_detail: sessionStorage["lead_campaign_detail"],
      landing_page: sessionStorage["lead_landing_page"],
      lead_source: sessionStorage["lead_lead_source"],
      marketing_code: sessionStorage["lead_marketing_code"],
      previous_page: document.referrer,
      referrer: sessionStorage["lead_referrer"],
      utm_campaign: sessionStorage["lead_utm_campaign"],
      utm_content: sessionStorage["lead_utm_content"],
      utm_medium: sessionStorage["lead_utm_medium"],
      utm_source: sessionStorage["lead_utm_source"],
      utm_term: sessionStorage["lead_utm_term"],
      ga: getCookie("_ga"),
      country: sessionStorage.hasOwnProperty("lead_meta")
        ? JSON.parse(sessionStorage["lead_meta"]).countryCode
        : {
          "de-at": "AT",
          de: "DE",
          "en-au": "AU",
          "en-ca": "CA",
          "en-gb": "GB",
          "en-ie": "IE",
          "en-nz": "NZ",
          "en-us": "US",
          "es-mx": "MX",
          "fr-be": "BE",
          fr: "FR",
          "nl-be": "BE",
          nl: "NL",
          pl: "PL",
        }[document.documentElement.lang],
    }
    return leadInfo
  }
}

export const setCookie = (name, value, days) => {
  var expires = ""
  if (days) {
    var date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = "; expires=" + date.toUTCString()
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/"
}

export const getCookie = (name) => {
  var nameEQ = name + "="
  var ca = document.cookie.split(";")
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == " ") c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

export const eraseCookie = (name) => {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;"
}
